import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { Lock, Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full border border-white/15 bg-ink/60 px-5 py-4 text-sm text-white placeholder:text-slate-600 outline-none transition-colors duration-300 focus:border-brand-orange";

export default function DefinirSenha() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("As senhas não coincidem.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/set-password`, { token, password });
      setDone(true);
    } catch (err) {
      const det = err.response?.data?.detail;
      setError(typeof det === "string" ? det : "Não foi possível definir a senha.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="flex min-h-screen items-center justify-center bg-ink px-6 py-24"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md border border-white/10 bg-navy/40 p-8 backdrop-blur-sm lg:p-10"
      >
        {done ? (
          <div className="text-center" data-testid="set-password-success">
            <span className="mx-auto flex h-14 w-14 items-center justify-center border border-emerald-400/50 text-emerald-400">
              <CheckCircle2 size={24} />
            </span>
            <h1 className="mt-6 font-display text-2xl font-bold text-white">Senha definida.</h1>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">
              Sua Área do Cliente está pronta. Entre com seu e-mail e a senha que você acabou de criar.
            </p>
            <Link
              to="/portal"
              data-testid="set-password-goto-portal"
              className="mt-8 inline-block bg-brand-orange px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-white transition-colors hover:bg-brand-red"
            >
              Acessar a Área do Cliente
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="set-password-form">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center border border-brand-orange/50 text-brand-orange">
                <Lock size={18} />
              </span>
              <div>
                <h1 className="font-display text-2xl font-bold text-white">Defina sua senha</h1>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                  Área do Cliente FUCHS
                </p>
              </div>
            </div>
            <div className="mt-8 space-y-5">
              <label className="block">
                <span className="mb-2 block font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">
                  Nova senha <span className="text-slate-600">(mínimo 8 caracteres)</span>
                </span>
                <input
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  data-testid="set-password-input"
                  className={inputCls}
                  placeholder="crie uma senha"
                />
              </label>
              <label className="block">
                <span className="mb-2 block font-mono text-[11px] uppercase tracking-[0.25em] text-slate-400">
                  Confirmar senha
                </span>
                <input
                  type="password"
                  required
                  minLength={8}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  data-testid="set-password-confirm"
                  className={inputCls}
                  placeholder="repita a senha"
                />
              </label>
              {error && (
                <p data-testid="set-password-error" className="border-l-2 border-brand-red pl-4 text-sm text-brand-red">
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={loading || !token}
                data-testid="set-password-submit"
                className="flex w-full items-center justify-center gap-3 bg-brand-orange px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] text-white transition-colors duration-300 hover:bg-brand-red disabled:opacity-60"
              >
                {loading && <Loader2 size={16} className="animate-spin" />}
                {loading ? "Salvando..." : "Definir senha e entrar"}
              </button>
              {!token && (
                <p className="text-center font-mono text-[10px] uppercase tracking-[0.2em] text-brand-red">
                  Link inválido — peça um novo à equipe Fuchs
                </p>
              )}
            </div>
          </form>
        )}
      </motion.div>
    </motion.main>
  );
}
